import { setGA4Event } from "@hardware/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, CloseOverlay } from "@insite/client-framework/Store/Context/Handlers/SignIn";


addToChainAfter(chain, CloseOverlay, props => {
    // Verndale Custom Tracking
    if (props.authenticatedSession) {
        const authenticationState = "Logged_in";
        const userId = props.authenticatedSession.userProfileId;
        setGA4Event("sign_in", [], {authenticationState,userId});
    } 
});